import { PageEnum } from '@/enums/pageEnum';

export const PAGE_NOT_FOUND_NAME = PageEnum.PAGE_NOT_FOUND;

export const LAYOUT = () => import('@/layout/index.vue');

export const REDIRECT_NAME = PageEnum.REDIRECT;

/**
 * 隐藏的路由名，不对业务开放
 */
export enum HidePageEnum {
    SVGPreview = 'SVGPreview',
    SVGPreviewDisplay = 'SVGPreviewDisplay',
    ModelPreview = 'ModelPreview',
}